import { render, staticRenderFns } from "./Diplomacy.vue?vue&type=template&id=d893dcca&"
import script from "./Diplomacy.vue?vue&type=script&lang=js&"
export * from "./Diplomacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports